<div class="wrap">
  <header>
    <h3 class="heading" *ngIf="view === 'search'">{{ data?.title || 'common.geoid.searchAddressHeading' | translate }}</h3>
    <h3 class="heading" *ngIf="view === 'list'">{{ data?.title || 'common.geoid.selectAddressHeading' | translate }}</h3>
    <button class="close-button" (click)="closeModal()"><span class="icon-close"></span></button>
  </header>
  <ng-container *ngIf="view === 'search'">
    <div class="content">
      <form id="geoIdSearchForm" [formGroup]="geoIdSearchForm" (ngSubmit)="search()">
        <div>
          <app-form-input 
            label="{{'common.fields.address.streetAddress' | translate }} *"
            placeholder="{{'common.fields.address.streetAddressPlaceholder' | translate}}"
            formControlName="streetAddress" 
            data-cy="streetAddress">
            <app-form-error *ngIf="streetAddress.touched && streetAddress.hasError('required')">
              {{'common.errors.invalidStreetAddress' | translate }}
            </app-form-error>
          </app-form-input>
          <app-form-input 
            label="{{'common.fields.address.postCode' | translate }} *" 
            formControlName="postalCode"
            data-cy="postalCode">
            <app-form-error *ngIf="postalCode.touched && postalCode.hasError('required')">
              {{'common.errors.invalidPostalCode' | translate }}
            </app-form-error>
          </app-form-input>
          <app-form-input 
            label="{{'common.fields.address.city' | translate }} *"
            formControlName="city" 
            data-cy="city">
            <app-form-error *ngIf="city.touched && (city.hasError('required') || city.hasError('pattern'))">
              {{'common.errors.invalidCity' | translate }}
            </app-form-error>
          </app-form-input>
          <app-form-input 
            label="{{'common.fields.address.unit' | translate }}" 
            formControlName="unit" 
            data-cy="unit">
          </app-form-input>
        </div>
      </form>
    </div>
    <footer>
      <button type="submit" form="geoIdSearchForm" class="bciti-button bciti-button--blue">
        <span *ngIf="!loading">{{ 'common.geoid.searchButton' | translate }}</span>
        <div *ngIf="loading" class="loading-spinner-wrap">
          <mat-progress-spinner
            mode="indeterminate"
            diameter="18">
          </mat-progress-spinner>
        </div>
      </button>
    </footer>
  </ng-container>
  <ng-container *ngIf="view === 'list'">
    <div class="content">
      <div *ngIf="loading" class="loading-spinner-wrap view">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="30">
        </mat-progress-spinner>
      </div>
      <form [formGroup]="geoIdAddressForm" *ngIf="!loading">
        <app-form-selection-list
          [data]="forceSearchUsed ? listDataForceSearch : listData"
          [initSelected]="true"
          formControlName="address"
        ></app-form-selection-list>
      </form>
      <p *ngIf="!forceSearchUsed">{{ 'common.geoid.cantFindPrompt' | translate }} 
        <button [disabled]="loading" class="bciti-inline-button" (click)="forceSearch()">
          {{ 'common.clickHere' | translate }}
        </button>
      </p>
      <p *ngIf="forceSearchUsed && listData.length > 0 && listDataForceSearch.length === 0">
        {{ 'common.geoid.couldntFindMoreResults' | translate }} {{ 'common.geoid.verifySearchCriteriaOrContactAdmin' | translate }}
      </p>
      <p *ngIf="forceSearchUsed && listData.length === 0 && listDataForceSearch.length === 0">
        {{ 'common.geoid.couldntFindAnyResults' | translate }} {{ 'common.geoid.verifySearchCriteriaOrContactAdmin' | translate }}
      </p>
    </div>
    <div class="subtype-selector" *ngIf="showSubTypeSelector && !loading">
      <label class="subtype-selector__label">{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }} *</label>
      <select class="subtype-selector__select" [(ngModel)]="selectedSubType" [ngModelOptions]="{standalone: true}">
        <option value="" disabled>{{ 'pages.user-cards.create.steps.information.subTypes.label' | translate }}</option>
        <option *ngFor="let opt of subTypeOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
    <footer>
      <button class="bciti-button bciti-button--blue" (click)="select()" [disabled]="geoIdAddressForm.invalid || (showSubTypeSelector && !selectedSubType)">{{ 'common.geoid.selectButton' | translate }}</button>
    </footer>
  </ng-container>
</div>
